import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import FilledButton from 'components/application/buttons/FilledButton';
import TextButton from 'components/application/buttons/TextButton';
import ModalBox from 'components/application/ModalBox';

export default function RemoveRequirementPriorityModal({
  courseName,
  isRequired,
  onClose,
  onConfirmRemoveRequirementPriority,
  personnelName,
  requirementPriorityReason,
  requirementPriorityUserName,
}) {
  const { t: i18nTCommon } = useTranslation('common');
  const { t: i18nT } = useTranslation('components', {
    keyPrefix:
      'training.requirementPriorityModals.RemoveRequirementPriorityModal',
  });

  const requirementStatus =
    isRequired ?
      i18nTCommon('shared.requiredDowncase')
    : i18nTCommon('shared.optionalDowncase');

  return (
    <ModalBox
      customFooter={
        <div className='modalbox__footer-actions modalbox__footer-actions--right'>
          <TextButton
            className='tw-mr-3'
            color='blue'
            onClick={onClose}
            size='md'
          >
            {i18nTCommon('shared.cancel')}
          </TextButton>
          <FilledButton
            color='mint'
            onClick={onConfirmRemoveRequirementPriority}
          >
            {i18nTCommon('shared.confirm')}
          </FilledButton>
        </div>
      }
      isOpen={true}
      modalBoxClassName='tw-w-140'
      mode='flexible'
      onClose={onClose}
    >
      <div className='tw-p-6'>
        <h2 className='tw-m-0 tw-p-0 tw-text-xl tw-font-semibold tw-text-grey-900'>
          {i18nT('title')}
        </h2>
        <p className='tw-mb-0 tw-ml-0 tw-mr-0 tw-mt-2 tw-p-0 tw-text-m tw-font-normal tw-text-grey-700'>
          {i18nT('existingRequirementPriorityReason', {
            interpolation: { escapeValue: false },
            userName: requirementPriorityUserName,
            requirementStatus,
            personnelName,
            courseName,
          })}
        </p>
        <div className='tw-mt-4 tw-flex tw-rounded-lg tw-border-0 tw-bg-amber-025 tw-p-3 tw-text-amber-800'>
          {requirementPriorityReason}
        </div>
      </div>
    </ModalBox>
  );
}

RemoveRequirementPriorityModal.propTypes = {
  courseName: PropTypes.string.isRequired,
  isRequired: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirmRemoveRequirementPriority: PropTypes.func.isRequired,
  personnelName: PropTypes.string.isRequired,
  requirementPriorityReason: PropTypes.string.isRequired,
  requirementPriorityUserName: PropTypes.string.isRequired,
};
